export const pets = [
  {
    id: 'pet-001',
    name: 'Max',
    image: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=200',
    ownerId: 'user-001'
  },
  {
    id: 'pet-002',
    name: 'Luna',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=200',
    ownerId: 'user-002'
  }
];

export const tasks = [
  {
    id: 'task-001',
    petId: 'pet-001',
    petName: 'Max',
    petImage: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=200',
    activities: [
      { type: 'paseo', time: '08:00', priority: 'high', status: 'pending', caregiver: 'Carlos', notes: 'Paseo matutino' },
      { type: 'comida', time: '09:30', priority: 'medium', status: 'completed', caregiver: 'Ana', notes: 'Dieta especial' }
    ],
    ownerId: 'user-001'
  }
];

export const users = [
  { id: 'user-001', name: 'Juan Pérez', role: 'owner' },
  { id: 'user-002', name: 'María Gómez', role: 'owner' },
  { id: 'user-003', name: 'Carlos Admin', role: 'admin' },
  { id: 'user-004', name: 'Ana Cuidadora', role: 'caregiver' },
  { id: 'user-005', name: 'Luis Cuidador', role: 'caregiver' }
];

// DONE